import { MY_STATE } from '@exodus/redux-dependency-injection';
const isLoadingSelectorDefinition = {
    id: 'isLoading',
    resultFunction: (assetsLoaded, { isLoading }) => !assetsLoaded || isLoading,
    dependencies: [{ module: 'assets', selector: 'loaded' }, { selector: MY_STATE }],
};
export default [isLoadingSelectorDefinition];
